import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'

// SVGs
import MenuSVG from '../../svg/menu.svg'
import CrossSVG from '../../svg/cross.svg'

// Component
const Navbar = () => {
  // Tracks page width, to change navbar style based on viewport size
  const [show, setShow] = useState(false)
  const [width, setWidth] = useState(1280)

  useEffect(() => {
    if (window.visualViewport) {
      setWidth(window.visualViewport.width)
      window.visualViewport.addEventListener('resize', () => {
        setWidth(window.innerWidth)
      })
    } else {
      setWidth(window.innerWidth)
      window.addEventListener('resize', () => {
        setWidth(window.innerWidth)
      })
    }
  }, [])

  useEffect(() => {
    if (width <= 768) {
      setShow(false)
    } else {
      setShow(true)
    }
  }, [width])

  // Render icon based on navmenu state
  const renderIcon = () => {
    return show ? (
      <CrossSVG
        onClick={() => {
          setShow(false)
        }}
      />
    ) : (
      <MenuSVG
        onClick={() => {
          setShow(true)
        }}
      />
    )
  }

  const getNavWidth = () => {
    if (width > 768) {
      return '100%'
    }
    if (!show) {
      return '0px'
    }
    return '100px'
  }

  return (
    <div
      className={`navbar ${show ? 'visible' : ''}`}
      style={{ width: getNavWidth() }}
    >
      <div className="logo">
        PS
        {renderIcon()}
      </div>
      <ul className="menu">
        <li>
          <a
            tabIndex="0"
            onClick={() => {
              document.getElementById('about').scrollIntoView()
            }}
          >
            About
          </a>
        </li>
        <li>
          <a
            tabIndex="0"
            onClick={() => {
              document.getElementById('skills').scrollIntoView()
            }}
          >
            Skills
          </a>
        </li>
        <li>
          <a
            tabIndex="0"
            onClick={() => {
              document.getElementById('projects').scrollIntoView()
            }}
          >
            Projects
          </a>
        </li>
        <li>
          <a
            tabIndex="0"
            onClick={() => {
              document.getElementById('contact').scrollIntoView()
            }}
          >
            Contact
          </a>
        </li>
        <li>
          <Link to="/blog">Blog</Link>
        </li>
      </ul>
    </div>
  )
}

export default Navbar
